




























































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faCameraRetro,
  faDownload,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

// Components
import FormAction from '@/components/common/FormAction.vue';
import BasicSelect from '@/components/common/BasicSelect.vue';
import BaseInput from '@/components/common/BaseInput.vue';
import BaseInputRadio from '@/components/common/BaseInputRadio.vue';
import DragDropFileUpload from '@/components/common/DragDropFileUpload.vue';
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
import BaseTextarea from '@/components/common/BaseTextarea.vue';
import PopupAddClinic from '@/components/common/PopupAddClinic.vue';
import PopupChangeStatus from '@/components/common/PopupChangeStatus.vue';
import Toast from '@common/helpers/toast';
import CkEditor from '@/views/diagnosis/CkEditor.vue';
import { Roles } from '@/common/app.config';
import ApiHelper from 'api-helper';
import { cloneDeep, isArray } from 'lodash';
import { Menu } from '@/models/menu';
import { Clinic } from '@/models/clinic';

@Component({
  components: {
    FormAction,
    BasicSelect,
    BaseInput,
    BaseInputRadio,
    BaseTextarea,
    PopupAddClinic,
    DragDropFileUpload,
    ToggleSwitch,
    CkEditor,
    PopupChangeStatus,
  },
})
export default class DiagnosisForm extends Vue {

  get clinicSelected() {
    return this.dataForm.clinics && this.dataForm.clinics.length
      ? cloneDeep(this.dataForm.clinics)
      : [];
  }

  get isCreate() {
    return this.$route.path.includes('/create');
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Roles.superAdmin;
  }

  get timeFrameOptions() {
    const data = [
      {
        name: '15分',
        value: 15,
      },
      {
        name: '30分',
        value: 30,
      },
      {
        name: '45分',
        value: 45,
      },
      {
        name: '60分',
        value: 60,
      },
    ];
    return data;
  }

  get displayFeeErrorMessages() {
    return {
      numeric: '正の数字を入力してください。',
    };
  }
  @Prop([String, Number]) diagnosisId: string | number;
  @Prop(Object) dataForm!: Menu;
  @Prop({ default: () => [], type: Array }) hiddenFields!: string[];
  @Prop(Boolean) disabledBtnCancel!: boolean;
  @Prop(Boolean) disabledBtnSubmit!: boolean;
  @Prop(Boolean) isEdit!: boolean;

  @State((state) => state.auth.currentUser) currentUser!: any;

  isSubmiting = false;
  isLoading: boolean = false;
  questions: any[] = [];
  role: string = '';
  listDoctors = [];
  selectedDoctors = [];
  isDefaultChange = this.dataForm.is_default;
  isLoadingSwitch = false;

  async created() {
    this.getQuestions();
    await this.listDoctorName();
    library.add(faCameraRetro);
    library.add(faDownload);
    library.add(faTrashAlt);
    dom.watch();
  }

  async getQuestions() {
    if (this.diagnosisId) {
      const params = {
        menu_id: this.diagnosisId,
      };
      const { data } = await ApiHelper.getApi('QuestionApi').getList(params);
      this.questions = data.sort((a, b) => a.order - b.order);
    }
  }

  mounted() {
    this.listDoctorName();
  }

  listDoctorName() {
    this.isLoading = true;
    ApiHelper.getApi('DoctorApi')
      .getList()
      .then((res: any) => {
        this.listDoctors = res.data?.map((doctor: any) => ({
          id: doctor.id,
          name: doctor.name,
        }));
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  handleDoctorIdsChange(selectedDoctors) {
    if (!Array.isArray(selectedDoctors)) {
      selectedDoctors = [selectedDoctors];
    }

    this.$emit('onChange', 'doctors', selectedDoctors);
  }

  goToQuestionListEdit() {
    if (this.diagnosisId) {
      const id = String(this.diagnosisId);
      this.$router.push({
        name: 'question.list-edit',
        params: { id },
      });
    }
  }
  goToPrecautionEdit() {
    if (this.diagnosisId) {
      const id = String(this.diagnosisId);
      this.$router.push({
        name: 'diagnosis.precaution',
        params: { id },
      });
    }
  }

  showPopup(event, name) {
    event.preventDefault();
    event.stopPropagation();

    this.$modal.show(name);
  }

  handleToggleSwitchChange(event) {
    this.isDefaultChange = event;
    if (this.isCreate) {
      this.handleSetIsDefaultChange({ isDefault: event, isCancel: false });
    } else {
      this.$modal.show('popup-change-status');
      this.isLoadingSwitch = true;
    }
  }

  handleSetIsDefaultChange(data) {
    const isDefault = data.isDefault;
    const isCancel = data.isCancel;

    if (isCancel) {
      this.$emit('onChange', 'is_default', this.dataForm.is_default);
      this.$modal.hide('popup-change-status');
      this.isDefaultChange = this.dataForm.is_default;
      this.isLoadingSwitch = false;
      return;
    }

    this.$emit('onChange', 'is_default', isDefault);

    if (isDefault) {
      this.isLoading = true;
      this.isLoadingSwitch = true;
      ApiHelper.getApi('ClinicApi')
        .list()
        .then((res: any) => {
          let clinics = [];
          if (this.currentUser.isAdminRole) {
            const curUserClinic = this.currentUser.clinics[0];
            const newRes = res.data.filter(
              (item) => item.id === curUserClinic.id,
            );
            clinics = newRes.map((item) =>
              new Clinic().deserialize(item),
            );
          } else {
            clinics = res.data.map((item) =>
              new Clinic().deserialize(item),
            );
          }

          this.dataForm.clinics = clinics;
        })
        .catch((error: any) => {
          Toast.error(error.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingSwitch = false;
          this.$modal.hide('popup-change-status');
        });
    } else {
      this.dataForm.clinics = [];
      this.isLoadingSwitch = false;
      this.$modal.hide('popup-change-status');
    }
  }

  hiddenPopup(name) {
    this.$modal.hide(name);
  }

  setClinic(data) {
    this.dataForm.clinics = isArray(data) ? data : [data];
  }

  changeValueImage(field: string, value: any) {
    if (value instanceof File) {
      // Emit the file directly for avatar
      this.$set(this.dataForm, field, value);
      this.$emit('onChange', field, value);

      // Create preview URL
      const reader = new FileReader();
      reader.onload = (event: any) => {
      this.$set(this.dataForm, 'image_url', event.target.result);
      this.$emit('onChange', 'image_url', event.target.result);
      };
      reader.readAsDataURL(value);
    }
  }

  handleDeleteImage() {
    this.$set(this.dataForm, 'image', null);
    this.$set(this.dataForm, 'image_url', '');
    this.$emit('onChange', 'image', null);
    this.$emit('onChange', 'image_url', '');
  }

  handleChange(name: string, value: any) {
    this.$set(this.dataForm, name, value);
  }

  @Watch('dataForm.is_free')
  private watchInputFee(_, oldValue) {
    if (![true, false].includes(oldValue)) {
      return;
    }
    if (!this.dataForm.is_free) {
      (this.$refs.inputFee as any).reset();
      return;
    }
    this.$emit('onChange', 'fee', '');
  }

  private handleCKEditorChange(content: string) {
    this.$emit('onChange', 'desc_html', content);
  }

  private handleUploadStateChange(isUploading: boolean) {
    this.$emit('onImageUploadStateChange', isUploading);
  }
}
